module.exports = __webpack_public_path__ + "static/media/img_Benchmarking403.6f7ea6c4.png";